export default "__VITE_ASSET__CXQyd$N9__"